import { HttpMethod } from 'gossamer-unified';
import { ConfigKey, getConfig, getConfigOrThrow } from '../ancillary/ConfigManager';
import { store } from './ReduxRoot';
import { logout } from './ReduxUser';

export class ClientError extends Error {
  readonly statusCode: number;
  constructor(statusCode: number, message: string) {
    super(message);
    this.statusCode = statusCode;
    if (statusCode < 500) {
      console.warn(statusCode, message);
    } else {
      console.error(statusCode, message);
    }
  }
}

export const fetchApi = async (method: HttpMethod, path: string, body?: any) => {
  const apiBaseUrl = getConfigOrThrow('gossamer-be-origin') + getConfigOrThrow('gossamer-api-path');
  const headers: Record<string, string> = {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'x-fe-path': location.pathname, // poor-main's tracing
  };
  const isLoginBypass = getConfig('login-bypass') === 'true';
  (['org-path', 'role-id', 'user-id'] as ConfigKey[]).forEach((configKey) => {
    const val = getConfig(configKey);
    if (val && isLoginBypass) {
      headers[`x-${configKey}`] = val;
    }
  });
  const resp = await fetch(`${apiBaseUrl}${path}`, {
    method,
    body: JSON.stringify(body),
    headers,
    credentials: 'include',
  });
  if (resp.status === 401) {
    store?.dispatch?.(
      logout({
        returnToOnceLoggedIn: window.location.href,
      }),
    );
    window.location.href = '/auth/login';
    throw new ClientError(401, 'Authentication required');
  }
  const jsonResponse = await resp.json();
  if (resp.status !== 200) {
    throw new ClientError(resp.status, jsonResponse.error || resp.statusText);
  }
  return jsonResponse;
};
